import React from 'react';
import PropTypes from 'prop-types';

/**
 * Info alert shown on the dashboard when the user has an in-progress 21a
 * application. The link resumes the form at its saved step.
 */
export const InProgressAlert = ({ href }) => (
  <va-alert status="info" visible>
    <h2 slot="headline">You have an in progress application</h2>
    <va-link
      href={href}
      text="Continue your application for accreditation (VA Form 21a)"
    />
  </va-alert>
);

InProgressAlert.propTypes = {
  href: PropTypes.string.isRequired,
};

/**
 * Success alert shown on the dashboard when the user has submitted a 21a
 * application. The link opens a review of the submitted application.
 */
export const SubmittedAlert = ({ href }) => (
  <va-alert status="success" visible>
    <h3 slot="headline">You submitted your application</h3>
    <va-link
      href={href}
      text="Review your application information and next steps"
    />
  </va-alert>
);

SubmittedAlert.propTypes = {
  href: PropTypes.string.isRequired,
};
